import $ from 'jquery';



if ($(window).width() < 600) {
    $('.footermain .footermain__title').on('click tap', function(){
        $(this).toggleClass('clicked');
        $(this).parent().find('.menuf').slideToggle();
    });
}

